import { Field, Layout } from "@introist/react-foundation/v2";
import { TextInput } from "../../../components/atoms";
import { ConnectFormProps } from "../views/DataSourceConnectionSetupView/steps/DataSourceConnectionForm";

type SaimaHrConfig = {
  apiKey: string;
  customerName: string;
};

export const SaimaHrConnectForm = ({ values, onChange }: ConnectFormProps) => {
  const credentials = (values?.credentials as SaimaHrConfig) ?? {
    apiKey: "",
    customerName: ""
  };

  return (
    <Layout.Group vertical gap="xLarge">
      <TextInput label="Name" value={values?.name} onChange={name => onChange({ name })} />
      <Field title="Customer Name">
        <TextInput
          placeholder="Customer name"
          value={credentials.customerName}
          onChange={customerName =>
            onChange({
              credentials: { ...credentials, customerName }
            })
          }
        />
      </Field>
      <Field title="API Key">
        <TextInput
          placeholder="API key"
          value={credentials.apiKey}
          type="password"
          onChange={apiKey =>
            onChange({
              credentials: { ...credentials, apiKey }
            })
          }
        />
      </Field>
    </Layout.Group>
  );
};
